import { useEffect, useState } from "react";
import { TextAreaWithDroppableFile } from "@jasper/forms";
import { OrderComment as OrderCommentType } from "@jasper/client-models";

export const CommentTextAreaWithFiles = ({
  orderComment,
  disabled,
  onFilesAdded,
  onFilesRemoved,
  onTextChange = () => {},
  bottomLeftSection,
}: {
  orderComment?: OrderCommentType;
  disabled?: boolean;
  onFilesAdded?: (files: File[]) => void;
  onFilesRemoved?: (files: File[]) => void;
  onTextChange?: (value: string) => void;
  bottomLeftSection?: React.ReactNode;
}) => {
  const [commentFiles, setCommentFiles] = useState<File[]>([]);

  useEffect(() => {
    if (!orderComment) {
      return;
    }

    Promise.all(orderComment.files.map(file => fetch(file.url)))
      .then(async responses => {
        const blobs = await Promise.all(responses.map(res => res.blob()));
        const files = blobs.map(
          (blob, index) =>
            new File(
              [blob],
              orderComment.files[index].filename || `file-${index}`
            )
        );
        setCommentFiles(files);
      })
      .catch(() => {
        setCommentFiles([]);
      });
  }, [orderComment]);

  return (
    <TextAreaWithDroppableFile
      placeholder={disabled ? undefined : "Un commentaire sur la commande ?"}
      onFilesAdded={onFilesAdded}
      onFilesRemoved={onFilesRemoved}
      onTextChange={onTextChange}
      defaultText={orderComment?.comment}
      files={commentFiles}
      disabled={disabled}
      autosize
      minRows={2}
      maxRows={5}
      filePreview
      bottomLeftSection={bottomLeftSection}
    />
  );
};
